import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';
import { createColumnHelper } from '@tanstack/react-table';
import { DateTime } from 'luxon';

import { DataGrid } from 'src/common/DataGrid';
import {
  MtmTransportationProviderRead,
  useBrokersMtmTransportationProvidersListQuery,
} from 'src/common/external/bambi-api/bambiApi';

import { ManageCell } from './MTMCells/ManageCell';
import { MTMSettingsFormModal } from './MTMSettingsFormModal';

const columnHelper = createColumnHelper<MtmTransportationProviderRead>();

const columns = [
  columnHelper.accessor('provider', {
    header: 'Provider',
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('org_code', {
    header: 'Vendor Code',
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('client_id', {
    header: 'Client ID',
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('webhook_id', {
    header: 'Webhook ID',
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('first_used', {
    header: 'First Used',
    cell: ({ row }) => {
      return (
        <div>
          {row.original.first_used
            ? DateTime.fromISO(row.original.first_used).toLocaleString(
                DateTime.DATETIME_MED
              )
            : '-'}
        </div>
      );
    },
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('last_used', {
    header: 'Last Used',
    cell: ({ row }) => {
      return (
        <div>
          {row.original.last_used
            ? DateTime.fromISO(row.original.last_used).toLocaleString(
                DateTime.DATETIME_MED
              )
            : '-'}
        </div>
      );
    },
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.display({
    id: 'manage',
    header: 'Manage',
    cell: ({ row }) => {
      return <ManageCell setting={row.original} />;
    },
    meta: {
      enableHeaderMenu: false,
    },
  }),
];

export function MTMSettingsDataGrid() {
  const { data, isLoading } = useBrokersMtmTransportationProvidersListQuery({});

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <>
      <DataGrid<MtmTransportationProviderRead>
        tableId="mtm-settings"
        columns={columns}
        data={data?.results || []}
        emptyState={<div>No MTM settings found</div>}
        totalCount={data?.count}
      />
      <MTMSettingsFormModal />
    </>
  );
}
